import React from 'react'

import { reverse } from 'named-urls'

import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  makeStyles,
  Typography,
  Box,
  Tooltip,
} from '@material-ui/core'

import { routes } from 'routes'
import { GenerateSkeleton } from 'components/Table'
import { LogIconButton } from 'components/Logs'
import Help from '@material-ui/icons/Help'
import constants from './../../../../../../constants'
import styles from './styles'

const SimplesNacionalCheck = ({ value }) => {
  if (!value) {
    return 'Não'
  }
  return 'Sim (Alíquota configurada de ' + value + '%)'
}

const useStyles = makeStyles(styles)

const SettingsNFeTableMarilia = ({ isLoading, settings, configGateway }) => {
  const classes = useStyles()
  return (
    <>
      <Divider />
      {isLoading ? (
        <Table>
          <TableBody>
            <GenerateSkeleton rows={1} cols={2} />

            <TableRow>
              <TableCell colSpan="2">
                <Typography variant="h5">Configurações de emissão</Typography>
              </TableCell>
            </TableRow>

            <GenerateSkeleton rows={5} cols={2} />
          </TableBody>
        </Table>
      ) : (
        <>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Gerar Nota Fiscal na criação da fatura?</TableCell>
                <TableCell>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {!!parseInt(settings.generateNFeOnInvoiceCreate.value)
                      ? 'Sim'
                      : 'Não'}
                  </Box>
                </TableCell>
              </TableRow>
              {!Number(settings.generateNFeOnInvoiceCreate?.value) && (
                <>
                  <TableRow>
                    <TableCell>
                      Gerar quantos dias antes do vencimento?
                    </TableCell>
                    <TableCell>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        {settings.daysToGenerateNFe.value}
                        <LogIconButton
                          to={reverse(routes.settings.logs, {
                            settingId: constants.settings.DAYS_TO_GENERATE_NFE,
                          })}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        Gerar nota fiscal dentro do mês corrente?
                        <Tooltip
                          className={classes.tooltipHelp}
                          classes={{ tooltip: classes.tooltipWidth }}
                          title="Ao gerar a fatura e agendar a geração da NFe conforme a configuração de dias antes do vencimento, caso a data de agendamento não seja o mês atual, gera a NFe no dia da geração da fatura."
                          placement="right"
                        >
                          <Help />
                        </Tooltip>
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        {!!parseInt(settings.generateInCurrentMonthNfe.value)
                          ? 'Sim'
                          : 'Não'}
                        <LogIconButton
                          to={reverse(routes.settings.logs, {
                            settingId:
                              constants.settings.GENERATE_IN_CURRENT_MONTH_NFE,
                          })}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                </>
              )}

              <TableRow>
                <TableCell>Alíquota para o Simples Nacional?</TableCell>
                <TableCell>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <SimplesNacionalCheck
                      value={settings.simplesNacionalNFe.value}
                    />
                    <LogIconButton
                      to={reverse(routes.settings.logs, {
                        settingId: constants.settings.SIMPLES_NACIONAL_NFE,
                      })}
                    />
                  </Box>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan="2">
                  <Typography variant="h5">Configurações de emissão</Typography>
                </TableCell>
              </TableRow>

              {configGateway.map(config => (
                <TableRow hover key={config.tag}>
                  <TableCell width="40%">{config.description}</TableCell>
                  <TableCell>{config.dataValue}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </>
  )
}

export default SettingsNFeTableMarilia
